import React, { useEffect, useState } from 'react';
import api from '../../common/api';
import makeStyles from "@material-ui/styles/makeStyles";
import { MaterialTable, PageHeader } from '../../components';
import useTheme from '@material-ui/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PPMobileCardView from '../../components/PPMobileCardView';

const useStyles = makeStyles(theme => ({
    root: props => ({
        // margin: props.isDesktop ? theme.spacing(4) : theme.spacing(1)
    }),
    topBar: {
        marginBottom: theme.spacing(2)
    },
}));

const MedicineStorageOverviewPage = ({ showError, showMessage }) => {
    const [medicineStorage, setMedicineStorage] = useState([]);
    const [loading, setLoading] = useState(false);

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });
    const classes = useStyles({ isDesktop });

    const getAllMedicineStorage = () => {
        setLoading(true);
        showError('');
        showMessage('');
        const response = api.post('/medicine-global-storage');
        response.then(res => {
            setMedicineStorage([...res]);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    showError('No Medicine Storage Found');
                else
                    showError(err.message);
            } else {
                showError('Unknown Error');
            }
        }).finally(() => {
            setLoading(false);
        });
        return response;
    };

    useEffect(() => {
        Promise.all([getAllMedicineStorage()]).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={classes.root}>
            <PageHeader title="Medicine Storage Overview" />
            <MaterialTable
                isLoading={loading}
                columns={[
                    { title: 'id', field: 'id', hidden: true },
                    {
                        title: 'Medicine Storage',
                        field: 'medicineStorageDetails',
                        hidden: isDesktop,
                        render: rowData => (
                            <PPMobileCardView
                                title={rowData.materialName}
                                rows={[
                                    { label: 'Material Type', value: rowData.materialType },
                                    { label: 'Available Quantity', value: rowData.availableStorage },
                                ]}
                            />
                        ),
                        // Other columns are hidden on mobile, and material-table skips hidden columns when searching
                        customFilterAndSearch: (term, rowData) => {
                            const values = [rowData.materialType, rowData.materialName, rowData.availableStorage];
                            return values.some(value => value !== undefined && value !== null &&
                                String(value).toLowerCase().includes(term.toLowerCase()));
                        },
                    },
                    { title: 'Material Type', field: 'materialType', hidden: !isDesktop, editable: 'never' },
                    { title: 'Material Name', field: 'materialName', hidden: !isDesktop, editable: 'never' },
                    { title: 'Available Quantity', field: 'availableStorage', hidden: !isDesktop, editable: 'never' },
                ]}
                title='Medicine Storage Overview'
                data={medicineStorage}
                options={{
                    actionsColumnIndex: -1,
                    search: true,
                    showTitle: true,
                    toolbar: true,
                    header: isDesktop,
                }}
            />
        </div>
    );
};

export default MedicineStorageOverviewPage;
